<div class="template-area__preview">
  <div class="prev-content custom-scroll-bar">
    <div class="chat-container p-2">
      <div class="chat-bubble">
        @if (getType()) {
          @if (getType() === "TEXT") {
            <p
              class="text-start p-2 text-dark fw-bold fs-5"
              [innerHTML]="formatWhatsappMessage(textHead)"
            ></p>
          } @else if (getType() === "IMAGE" && textHead) {
            <div class="bg-light-subtle upload-container py-2 px-1">
              <label for="fileUpload" class="w-100 d-block">
                <img
                  class="rounded-lg"
                  [src]="textHead"
                  alt="image"
                  style="width: 100%; height: 100%; object-fit: cover"
                />
              </label>
            </div>
          } @else if (getType() === "DOCUMENT" && textHead) {
            <div
              class="bg-light-subtle upload-container py-2 px-1"
              style="text-align: center"
            >
              <label for="fileUpload" class="w-100 d-block">
                <i
                  class="mdi mdi-file-document-outline fs-1 text-secondary"
                ></i>
                <span class="d-block text-truncate fw-semibold">{{
                  "campaign.cloudApiTemplate.file" | translate
                }}</span>
              </label>
            </div>
          } @else if (getType() === "VIDEO" && textHead) {
            <div
              class="bg-light-subtle upload-container py-2 px-1"
              style="text-align: center"
            >
              <label for="fileUpload" class="w-100 d-block">
                <video width="100%" height="auto" controls>
                  <source [src]="textHead" type="video/mp4" />
                  {{ "campaign.template.videoNotSupported" | translate }}
                </video>
              </label>
            </div>
          }
        }
        <p
          class="text-start p-2 text-dark fw-semibold fs-5"
          [innerHTML]="formatWhatsappMessage(inputText)"
        ></p>
        @if (footerComponent) {
          <div class="wa-footer text-sm">
            <p>{{ footerComponent?.text }}</p>
          </div>
        }
        @if (buttonsComponent) {
          <div class="text-sm d-flex flex-column align-items-center w-100 my-3">
            @for (button of buttonsComponent?.buttons; track $index) {
              <div
                class="d-flex align-items-center justify-content-center w-100 border-top py-1 fs-5 fw-medium text-primary"
              >
                @if (getTypeButton($index) === "PHONE_NUMBER") {
                  <i class="ri-phone-line me-2 fs-5"></i>
                } @else if (getTypeButton($index) === "URL") {
                  <i class="ri-share-box-line me-2 fs-5"></i>
                } @else if (getTypeButton($index) === "QUICK_REPLY") {
                  <i class="ri-reply-line me-2 fs-5"></i>
                } @else if (getTypeButton($index) === "COPY_CODE") {
                  <i class="ri-file-copy-line me-2 fs-5"></i>
                }
                <span>{{ button.text }}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
